<template>
        <modal @close="$emit('close')" width="95%" max-width="500px">
            <div slot="title">{{$t('hint_title')}}</div>
            <div class="modal-content-wrapper container-fluid" style="font-size: smaller;">
                <div class="row">
                    <div class="col-12 d-block h-auto">
                        <div class="text-muted mt-2" v-html="$t('hint')"></div>
                        <table class="mt-3 table table-bordered table-sm mb-0">
                            <tr>
                                <th>{{$t('character_length')}}</th>
                                <th>{{$t('price_for_length')}}</th>
                            </tr>
                            <tr>
                                <td>{{$t('n_chars', {n: '1~70'})}}</td>
                                <td>{{$t('n_credit', {credits: 1, price: 1.5})}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('n_chars', {n: '71~134'})}}</td>
                                <td>{{$t('n_credit', {credits: 2, price: 3})}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('n_chars', {n: '135~201'})}}</td>
                                <td>{{$t('n_credit', {credits: 3, price: 4.5})}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('n_chars', {n: '202~268'})}}</td>
                                <td>{{$t('n_credit', {credits: 4, price: 6})}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('n_chars', {n: '269~333'})}}</td>
                                <td>{{$t('n_credit', {credits: 5, price: 7.5})}}</td>
                            </tr>
                        </table>
                        <div class="text-muted mb-3">{{$t('international_message_hint')}}</div>
                    </div>
                </div>
            </div>
        </modal>
</template>

<script>
import Modal from '../common/Modal';
export default {
	components: { Modal }

}
</script>

<style>

</style>

<i18n>
{
    "en": {
        "hint_title": "SMS Information",
        "hint": "Credits are deducted according to the length of message sent.Please refer to following table.<br><br>1 credit = NT$1.5<br>You can setup timing to send SMS notification in \"SMS Preferences\" Tab.",
        "character_length": "Length",
        "price_for_length": "Pricing",
        "n_chars": "{n} character|{n} characters",
        "n_credit": "{credits} credits (NT${price})",
        "international_message_hint": "*Above table shows the pricing to send to number in Taiwan which starts with \"+886\". For other countries, the pricing is trippled."
    },
    "zh": {
        "hint_title": "費率",
        "hint": "簡訊依傳送訊息之長度計算扣點，訊息長度與使用點數請參考下表。<br><br>儲值點數，一點為台幣 1.5 元。<br>您可以在「簡訊發送設定」調整要使用簡訊傳送的通知類型。",
        "character_length": "字數",
        "price_for_length": "價格",
        "n_chars": "{n} 字元",
        "n_credit": "{credits} 點 (NT${price})",
        "international_message_hint": "*上表為寄送至 +886 開頭的號碼費率，若為其他國家號碼，費率以三倍計算。"
    }
}
</i18n>